module.exports = __webpack_public_path__ + "img/plat_2802.4b2ec473.jpg";